// extracted by mini-css-extract-plugin
module.exports = {"colors":"Colors_colors__7FOaW","sampleContainer":"Colors_sampleContainer__3dfw7","codeContainer":"Colors_codeContainer__1o42J","copy":"Colors_copy__PEaGL"};